var render = function render(){var _vm=this,_c=_vm._self._c;return _c('VueRecaptcha',{attrs:{"sitekey":this.sitekey,"loadRecaptchaScript":true},on:{"verify":_vm.emitKey}})
}
var staticRenderFns = []

export { render, staticRenderFns }